import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ListiniVenditaRoutingModule } from "./listiniVendita-routing";
import { ListiniVenditaComponent } from "./listini-vendita.component";
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {TranslateModule} from '@ngx-translate/core';
import { docSearchPipe } from "./doc-search.pipe";
import { FormsModule } from '@angular/forms';
import { Ng2SearchPipeModule } from "ng2-search-filter";


@NgModule({
    imports: [
      CommonModule,
      ListiniVenditaRoutingModule,
      NgbModule,
      TranslateModule,
      FormsModule,
      Ng2SearchPipeModule
    ],
    declarations: [ListiniVenditaComponent,docSearchPipe]
  })
  export class listiniVenditaModule { }